import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const GallerySelectUploadListPlusIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width={48} height={48} viewBox="0 0 256 256" {...props}>
      <path fill="currentColor"
            d="M220 128a4 4 0 0 1-4 4h-84v84a4 4 0 0 1-8 0v-84H40a4 4 0 0 1 0-8h84V40a4 4 0 0 1 8 0v84h84a4 4 0 0 1 4 4Z"/>
    </SvgIcon>
  );
};


